var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.65587 7.34436C1.32919 6.94457 0.740998 6.88588 0.342098 7.21329C-0.0568023 7.54069 -0.115353 8.1302 0.211321 8.52999L4.40079 13.6571C4.80006 14.1458 5.55773 14.1057 5.90353 13.5778L13.8468 1.44918C14.1297 1.01718 14.0096 0.43711 13.5786 0.153555C13.1476 -0.130001 12.5688 -0.00966466 12.2859 0.422333L5.04005 11.486L1.65587 7.34436Z","fill":"#1C232B"}));
}

Check.displayName = "Check";

Check.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Check;

Check.default = Check;
